import Nullstack from 'nullstack';
export default function IconGitBranchDeleted({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-git-branch-deleted",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "7",
    cy: "18",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "7",
    cy: "6",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M7 8v8"
  }), "   ", Nullstack.element("path", {
    d: "M9 18h6a2 2 0 0 0 2 -2v-5"
  }), "   ", Nullstack.element("path", {
    d: "M14 14l3 -3l3 3"
  }), "   ", Nullstack.element("path", {
    d: "M15 4l4 4"
  }), "   ", Nullstack.element("path", {
    d: "M15 8l4 -4"
  }), " ");
}